var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFunnel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1112 1.33337C14.3214 1.33337 14.5136 1.45207 14.6078 1.64004C14.6904 1.80479 14.6852 1.99799 14.598 2.15659L14.5556 2.22226L9.33337 9.33337V13.3334L8.11116 14.4445C7.91896 14.589 7.68495 14.667 7.44449 14.6667L7.26593 14.6631C6.82785 14.6464 6.68719 14.5587 6.66877 14.092L6.66671 14V9.33337L1.44449 2.22226C1.31823 2.05392 1.29792 1.82869 1.39203 1.64048C1.47437 1.47579 1.63195 1.36418 1.81103 1.33885L1.88893 1.33337H14.1112ZM4.12227 2.44449H3.56671C3.4615 2.44449 3.36531 2.50393 3.31826 2.59804C3.28062 2.67332 3.27959 2.76045 3.313 2.83539L3.34449 2.88893L6.08671 6.50004C6.15845 6.59569 6.28335 6.63471 6.39677 6.5969C6.494 6.56449 6.5641 6.48187 6.58214 6.38363L6.58671 6.33337V5.63893C6.58671 5.59886 6.57805 5.55951 6.56159 5.52349L6.53115 5.47226L4.34282 2.5556C4.30114 2.50001 4.24057 2.46259 4.17355 2.44957L4.12227 2.44449Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnel);
export default __webpack_public_path__ + "static/media/funnel.cc87c0f8.svg";
export { ForwardRef as ReactComponent };